import moment from 'moment/moment';
import React from 'react';

let yesterdaysDate = moment().subtract(1, 'days').format("YYYY-MM-DD");

const FooterMenu = () => (
    <footer className="footer">
        <div className="float-start">
            Last Refresh : { yesterdaysDate } @ 07:30AM
        </div>
        <div className="float-end">
            Build: 06.10.2023
        </div>
    </footer>
);
 
export default FooterMenu;